require('./payrollLoanRequestStepProduct.scss');
const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @core
const { FormattedText } = require('core/i18n').i18n;

//@assets
const assistance = require('assets/images/24-h-assistance.svg');
const interests = require('assets/images/interests.svg');
const moneyBill = require('assets/images/money-bill.svg');
const personalManager = require('assets/images/personal-manager.svg');

class PayrollLoanRequestStepProduct extends React.Component {
    buildBenefits(collectiveTexts) {
        const poeditorPrefix = this.getPoeditorPrefix();
        const interestDescription = (
            <span>
                <FormattedText value={collectiveTexts.interest} className="payroll-loan-request-step-product__interest" />
                <sup>
                    <FormattedText value={`${poeditorPrefix}-interestDescription2`} />
                </sup>
                <FormattedText value={collectiveTexts.interest2} className="payroll-loan-request-step-product__interest" />
                <sup>
                    <FormattedText value={`${poeditorPrefix}-interestDescription4`} />
                </sup>
                .
            </span>
        );

        const items = [
            {
                icon: interests,
                title: `${poeditorPrefix}-interest`,
                description: interestDescription
            },
            {
                icon: moneyBill,
                title: collectiveTexts.commision,
                description: <FormattedText value={`${poeditorPrefix}-commissionDescription`}/>
            },
            {
                icon: assistance,
                title: `${poeditorPrefix}-${poeditorPrefix}_years`,
                description: <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_yearsDescription`} />
            },
            {
                icon: personalManager,
                title: `${poeditorPrefix}-personalized`,
                description: <FormattedText value={`${poeditorPrefix}-personalizedDescription`} />
            }
        ]

        return items.map((item, index) => {
            return (
                <div key={`benefit-${index}`} className={`col-xs-6 payroll-loan-request-step-product__benefits payroll-loan-request-step-product__benefits-border-${index}`}>
                    <img src={item.icon} className={`payroll-loan-request-step-product__beneftis-icon ${item.icon}`} />
                    <div className="payroll-loan-request-step-product__benefits-texts-container">
                        <div className="payroll-loan-request-step-product__benefits-title">
                            <FormattedText value={item.title} />
                        </div>
                        <div className="payroll-loan-request-step-product__benefits-subtitle">
                            {item.description}
                        </div>
                    </div>
                    
                </div>
            );
        });
    }

    getPoeditorPrefix() {
        return 'payrollLoanRequestStepProduct';
    }

    buildCollectiveTexts() {
        const { immPayrollLoanRequest } = this.props;
        const isCollective = immPayrollLoanRequest.get('isCollective');
        const collectiveName = immPayrollLoanRequest.get('collectiveName');
        const poeditorPrefix = this.getPoeditorPrefix();

        return {
            subtitle: isCollective ? (
                <FormattedText value={`${poeditorPrefix}-subtitleCollective`}
                    injectedStrings={[collectiveName.trim()]} />
            ) : null,
            interest: isCollective ? `${poeditorPrefix}-${poeditorPrefix}_interestDescriptionCollective1` :
                `${poeditorPrefix}-${poeditorPrefix}_interestDescription1`,
            interest2: isCollective ? `${poeditorPrefix}-${poeditorPrefix}_interestDescriptionCollective3` :
                `${poeditorPrefix}-${poeditorPrefix}_interestDescription3`,
            commision: isCollective ? `${poeditorPrefix}-${poeditorPrefix}_commissionCollective` :
                `${poeditorPrefix}-${poeditorPrefix}_commission`,
            bullet1: isCollective ? `${poeditorPrefix}-${poeditorPrefix}_bullet1text1Collective` :
                `${poeditorPrefix}-${poeditorPrefix}_bullet1text1`,
            bullet2: isCollective ? `${poeditorPrefix}-${poeditorPrefix}_bullet2text1Collective` :
                `${poeditorPrefix}-${poeditorPrefix}_bullet2text1`
        }
    }

    buildPrecontractualInfo() {
        const { downloadPreContractDocument, footerLinkCentered } = this.props;
        const footerClassname = `contract-view-step1${footerLinkCentered ? '__footer-link-centered' : '__footer'}`;
        return (
            <div className={footerClassname}>
                <a 
                    className="contract-view-step1__footer-link contract-view-step1__footer-link__without-icon" 
                    onClick={downloadPreContractDocument}>
                        <FormattedText value="payrollLoanPrecontractual-payrollLoanPrecontractual_titleIne"/> 
                </a>
            </div>
        )
    }

    render() {
        const collectiveTexts = this.buildCollectiveTexts();
        const benefits = this.buildBenefits(collectiveTexts);
        const precontractualInfo = this.buildPrecontractualInfo();
        return (
            <section className="payroll-loan-request-step-product">
                <div className="row">
                    <div className="col-xs-12 payroll-loan-request-step-product__title">
                        <FormattedText value="payrollLoanRequestStepProduct-title" />
                    </div>
                    <div className="col-xs-12 payroll-loan-request-step-product__subtitle">
                        <FormattedText value="payrollLoanRequestStepProduct-subtitle" />
                        {collectiveTexts.subtitle}
                    </div>
                    <div className="col-xs-12 payroll-loan-request-step-product__subtitle2">
                        <FormattedText value="payrollLoanRequestStepProduct-subtitle2" />
                    </div>
                </div>
                <div className="row">
                    <div className="payroll-loan-request-step-product__benefits-container">
                        {benefits}
                    </div>
                </div>
                {precontractualInfo}
            </section>
        );
    }
}

PayrollLoanRequestStepProduct.propTypes = {
    immPayrollLoanRequest: PropTypes.object.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    footerLinkCentered: PropTypes.bool
}

module.exports = PayrollLoanRequestStepProduct;
